import { useLayoutEffect, useState } from 'react';
const isServerEnvironment = typeof window === 'undefined';
// Во время серверного рендеринга подписка на изменение стора не создается,
// поэтому можно безопасно вызвать изменение стора во время рендеринга компонента
const useIsomorphicLayoutEffect = isServerEnvironment ? (effect) => effect() : useLayoutEffect;
/**
 * Вызывает экшен до первой вставки компонента в DOM.
 * Хук использует `useLayoutEffect`, чтобы дождаться ререндера компонента после изменения данных в сторе.
 *
 * @param initAction Вызываемый экшен. Экшен будет вызыван повторно при изменении ссылки на функцию
 * @returns true, если компонент был замаунчен и экшен был вызван первый раз. Важно не рендерить дочерние компоненты,
 * если хук возвращает `false`. Иначе возможны баги с двойным вызовом `useEffect`
 */
export const useSyncInitialAction = (initAction) => {
    const [inited, setInited] = useState(isServerEnvironment);
    useIsomorphicLayoutEffect(() => {
        initAction();
        // Первый вызов useLayoutEffect происходит еще до появления подписок на сторы,
        // поэтому триггерим повторный рендеринг вручную, чтобы селекторы в компоненте подхватили актуальные значения.
        if (!isServerEnvironment && !inited) {
            setInited(true);
        }
    }, [initAction]);
    return inited;
};
